let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6gau7")).then(() => parcelRequire('90bwg'));